import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiChevronRight } from 'react-icons/fi';
import NotificationItem from './NotificationItem';

export default function NotificationSection({
  title,
  icon: Icon,
  items = [],
  type,
  accentColor = 'gray',
  defaultOpen = true,
  lastSeenAt,
  onAssign,
  onCloseItem,
  onOpenItem,
  assignableUsers,
}) {
  const [open, setOpen] = useState(defaultOpen);
  const count = items.length;

  const countColorMap = {
    coral: 'bg-red-500 text-white',
    amber: 'bg-amber-500 text-white',
    blue: 'bg-blue-500 text-white',
    violet: 'bg-violet-500 text-white',
    emerald: 'bg-emerald-500 text-white',
    red: 'bg-red-600 text-white',
    gray: 'bg-gray-500 text-white',
  };

  return (
    <div className="border-b border-gray-100 dark:border-gray-800/60 last:border-b-0">
      {/* Section header */}
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center gap-2 px-4 py-2.5 text-left hover:bg-gray-50/50 dark:hover:bg-white/[0.02] transition-colors"
      >
        <motion.div
          animate={{ rotate: open ? 90 : 0 }}
          transition={{ duration: 0.15 }}
          className="flex-shrink-0"
        >
          <FiChevronRight className="w-3.5 h-3.5 text-gray-400 dark:text-gray-500" />
        </motion.div>
        {Icon && <Icon className="w-3.5 h-3.5 text-gray-500 dark:text-gray-400 flex-shrink-0" />}
        <span className="text-[11px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 flex-1">
          {title}
        </span>
        {count > 0 && (
          <span className={`
            min-w-[18px] h-[18px] flex items-center justify-center rounded-full text-[10px] font-bold leading-none px-1
            ${countColorMap[accentColor] || countColorMap.gray}
          `}>
            {count}
          </span>
        )}
      </button>

      {/* Items */}
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="overflow-hidden"
          >
            {items.length === 0 ? (
              <div className="px-4 py-3 text-[11px] text-gray-400 dark:text-gray-500 italic">
                None right now
              </div>
            ) : (
              <div className="divide-y divide-gray-50 dark:divide-gray-800/40">
                {items.map((item, idx) => (
                  <NotificationItem
                    key={item._id || item.id || idx}
                    item={item}
                    type={type}
                    isNew={lastSeenAt ? new Date(item.createdAt) > new Date(lastSeenAt) : false}
                    accentColor={accentColor}
                    onAssign={onAssign}
                    onClose={onCloseItem}
                    onOpen={onOpenItem}
                    assignableUsers={assignableUsers}
                  />
                ))}
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
